import { Scenarios } from '@jfs/network'

const getBankIfsc = {
  default: [
    {
      url: /remittance\/jpb\/v2\/crm\/getIFSCCode/,
      method: 'POST',
      response: [
        {
          ifscCode: 'ICIC0007246',
          bankName: 'ICICI BANK LIMITED',
        },
      ],
      delay: 500,
    },
  ],
  failed: [
    {
      url: /remittance\/jpb\/v2\/crm\/getIFSCCode/,
      method: 'POST',
      responseCode: 500,
      response: [
        {
          ifscCode: 'ICIC0007246',
          bankName: 'ICICI BANK LIMITED',
          errorCode: '500',
          errorMsg: 'IFSC Code Not found',
        },
      ],
      delay: 1000,
    },
  ],
} as Scenarios

export { getBankIfsc }
